// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"74":"e25b8687","1913":"40ec16c6"}[chunkId] || chunkId) + "." + {"74":"9bd6ab81441a4861","1913":"b52bbea464b2d6f4","3089":"db6255a8f3100343"}[chunkId] + ".js";
};